export const minWidth600 = '@media only screen and (min-width: 600px)';
export const minWidth820 = '@media only screen and (min-width: 820px)'; // iPad Air width
export const minWidth870 = '@media only screen and (min-width: 870px)';
export const minWidth1024 = '@media only screen and (min-width: 1024px)';
